import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Card = ({ children, title, className = '', padding = 'md', }) => {
    const paddingStyles = {
        none: '',
        sm: 'p-3',
        md: 'p-4',
        lg: 'p-6',
    };
    return (_jsxs("div", { className: `bg-white rounded-lg shadow-md ${className}`, children: [title && (_jsx("div", { className: "border-b border-gray-200 px-4 py-3", children: _jsx("h3", { className: "text-lg font-medium text-gray-900", children: title }) })), _jsx("div", { className: paddingStyles[padding], children: children })] }));
};
//# sourceMappingURL=Card.js.map